<template>
  <div class="card shadow-sm mt-10">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <h2 class="text-dark mb-0">{{$t('qvct_survey.survey_report.respondents_feedback')}}</h2>
      </div>

      <div v-if="(surveyResponses?.questions || []).length === 0" class="text-center py-10">
        <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
        <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
      </div>

      <div v-else>
        <div class="mb-7" v-for="q in surveyResponses.questions" :key="q.question_id">
          <div v-if="(q.responses || []).length > 0" class="horizontal-scroll">
            <div class="opinion-card card shadow-sm" v-for="(r, idx) in (q.responses || [])" :key="idx">
              <div class="card-body d-flex flex-column gap-2">
                <div class="text-dark" style="white-space: pre-wrap;">{{ r.response_text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  surveyOpinion: { type: Object, default: () => ({ survey_id: null, questions: [] }) }
})

const surveyResponses = ref({ survey_id: null, questions: [] })

watch(() => props.surveyOpinion, (val) => {
  try {
    const normalized = val && typeof val === 'object' ? val : { survey_id: null, questions: [] }
    surveyResponses.value = normalized
  } catch (_) {
    surveyResponses.value = { survey_id: null, questions: [] }
  }
}, { immediate: true, deep: true })
</script>

<style scoped>
.horizontal-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
}

.opinion-card {
  min-width: 320px;
  max-width: 420px;
  flex: 0 0 auto;
}
</style>


